<!--<div class="widget">
    <h4>Who to Follow</h4>
    <ul>
        <li *ngFor="let user of suggestedUsers">
            <div class="col-1 mt-2" style="display:table-cell !important;">
                <div class="user-avatar-container-top">
                    <img [src]="'api/content/logo?userID=' + user.UserId" class="avatar">
                </div>
            </div>
            <div class="col-11 ">
                <div class="follow-row">
                    <div class="profile-link">{{ user?.ProfileName }}</div>
                    <div class="profile-username-link">&#64;{{ user?.UserName }}</div>-->

                    <!--<button class="follow-btn">Follow</button>-->
                    <!--<button (click)="followUser(user.UserId, false); $event.stopPropagation()">Follow</button>

                </div>
            </div>
        </li>
    </ul>
</div>-->

<div class="widget">
    <h4>Who to Follow</h4>

    <div class="follow-list">
        <div *ngFor="let user of suggestedUsers"
             class="d-flex flex-nowrap align-items-center follow-item w-100">
            <!-- Avatar Column -->
            <div class="me-2">
                <div class="user-avatar-container">
                    <img [src]="'api/content/logo?userID=' + user.UserId" class="avatar">
                </div>
            </div>

            <!-- User Info Column -->
            <div class="flex-grow-1 min-w-0">
                <!--<div class="user-info">-->
                <div class="profile-link text-truncate">{{ user?.ProfileName }}</div>
                <div class="profile-username-link">&#64;{{ user?.UserName }}</div>
                <!--</div>-->
            </div>

            <!-- Follow Button Column -->
            <div class="ms-2">
                <button class="follow-btn" (click)="followUser(user.UserId, false); $event.stopPropagation()">
                    Follow
                </button>
            </div>
        </div>
    </div>
</div>
